import { useQuery } from '@tanstack/react-query';
import useDispatchify from 'common/hooks/utils/useDispatchify';
import {
  getSensorScopesValidation,
  TOKEN_VALIDATION_STATUS
} from 'common/services/sensors.service';
import { useMemo } from 'react';
import { getSensorAuthorizations as getSensorAuthorizationsCaller } from 'state/callers';
import { FEATURE_FLAGS_NAMES } from '@linearb/linjs-common';
import useSettingsService from 'components/hooks/useSettingsService';

const useScopesValidations = ({ sensor, enabled }) => {
  const { getSettingOrDefinitionValue } = useSettingsService();
  const getSensorAuthorizations = useDispatchify(getSensorAuthorizationsCaller);

  const isGitHubAppIntegrationEnabled = getSettingOrDefinitionValue({
    name: FEATURE_FLAGS_NAMES.isGitHubAppIntegrationEnabled
  });
  const {
    data = {},
    isLoading,
    isError,
    refetch
  } = useQuery({
    enabled,
    staleTime: 0,
    cacheTime: 0,
    retry: false,
    keepPreviousData: false,
    refetchOnMount: true,
    refetchOnReconnect: true,
    queryKey: ['scopesValidations', sensor?.id, enabled],
    queryFn: async () => {
      return await getSensorScopesValidation(sensor?.id);
    },
    onSuccess: () => {
      getSensorAuthorizations({
        withoutGitHubApp: !isGitHubAppIntegrationEnabled
      });
    }
  });

  const missingScopes = useMemo(() => data?.missing_scopes || [], [data]);
  const scopes = sensor?.profile?.scopes || [];

  const isValid = data?.token_status === TOKEN_VALIDATION_STATUS.VALID;

  return {
    isValid,
    isLoading,
    isError,
    refetch,
    missingScopes,
    scopes
  };
};

export default useScopesValidations;
